import { Component } from "react";
import { withRouter } from "react-router-dom";

interface ScrollState {}

class ScrollToTop extends Component<any, ScrollState> {
  componentDidUpdate(prevProps: any) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
